"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSectionTemplate = useSectionTemplate;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = require("react");
const url_1 = require("../../services/url"); // Adjust the import path
const react_router_1 = require("react-router");
function useSectionTemplate(props) {
    const location = (0, react_router_1.useLocation)();
    const [preloaded, setPreloaded] = (0, react_1.useState)(false);
    // Call preload upon the first mount of the component
    (0, react_1.useEffect)(() => {
        if (typeof props.sectionConfig.preload === 'function') {
            props.sectionConfig.preload(props.interview, {
                startUpdateInterview: props.startUpdateInterview,
                startAddGroupedObjects: props.startAddGroupedObjects,
                startRemoveGroupedObjects: props.startRemoveGroupedObjects,
                startNavigate: props.startNavigate,
                callback: () => setPreloaded(true),
                user: props.user
            });
        }
        else {
            setPreloaded(true);
        }
    }, []);
    // Scroll to first invalid component, if any
    (0, react_1.useEffect)(() => {
        if (!props.allWidgetsValid && props.submitted && props.loadingState === 0) {
            // Scroll to the position of the first invalid question in all
            // cases. Some browsers, like Safari iOS have security features
            // preventing focus without explicit user interaction (and this is
            // not considered one)
            const firstInvalidElement = document.getElementsByClassName('question-invalid')[0];
            if (firstInvalidElement) {
                firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
            // Not all widgets types focus correclty on all browsers, so we do the
            // actual focus only on text widgets.
            const invalidInputs = document.querySelectorAll('.question-invalid input');
            if (invalidInputs.length > 0 && invalidInputs[0].id && invalidInputs[0].type === 'text') {
                // Focus on invalid input if found, it has an ID, and is of type text
                const inputElement = document.getElementById(invalidInputs[0].id);
                if (inputElement) {
                    inputElement.focus();
                }
            }
        }
    }, [props.allWidgetsValid, props.submitted, props.loadingState]);
    // Update the URL to match the section
    const path = (0, url_1.getPathForSection)(location.pathname, props.shortname);
    if (path && location.pathname !== path) {
        window.history.replaceState(null, '', path);
    }
    return { preloaded };
}
//# sourceMappingURL=useSectionTemplate.js.map